/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PlacementTypeEnum = 'DirektAngestellt' | 'Arbeitnehmerueberlassung' | 'Arbeitnehmervermittlung' | 'KeineAngabe';

export const PlacementTypeEnum = {
    DirektAngestellt: 'DirektAngestellt' as PlacementTypeEnum,
    Arbeitnehmerueberlassung: 'Arbeitnehmerueberlassung' as PlacementTypeEnum,
    Arbeitnehmervermittlung: 'Arbeitnehmervermittlung' as PlacementTypeEnum,
    KeineAngabe: 'KeineAngabe' as PlacementTypeEnum
};

